import React from "react";
import {I18n} from "react-redux-i18n";
import TextField from "../../../shared/components/fields/textField/TextField";
import PropTypes from "prop-types";

const UrlConfigField = ({
    name,
    fieldConfig,
    value,
    handleOnFieldBlur,
    handleFieldChange,
}) => {
    return <div className="row">
        <TextField
            value={value}
            label={I18n.t("dashboard.widgets.formsFields.url")}
            handleFieldChange={value => handleFieldChange(name, value)}
            handleFieldBlur={() => handleOnFieldBlur(name)}
            isRequired={fieldConfig.required}
            themeName="form"
            width={12}
        />
    </div>
};

UrlConfigField.propTypes = {
    name: PropTypes.string,
    fieldConfig: PropTypes.object,
    value: PropTypes.string,
    handleOnFieldBlur: PropTypes.func,
    handleFieldChange: PropTypes.func,
};

export default UrlConfigField;